import { isEmpty } from 'lodash';
import { useIntl } from 'react-intl';

import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';

import { Citation, Message } from '../../../types/chat';
import { Citations } from './Citations';
import { Sources } from './Sources';

interface Props {
  message: Message;
  onSelectSource?: (message: Message, sourceIndex: number) => void;
  onSelectCitation: (citation: Citation) => void;
}

export const SourcesList = ({
  message,
  onSelectCitation,
  onSelectSource,
}: Props) => {
  const intl = useIntl();
  const { sources: originalSources = [], citations } = message;

  if (!originalSources.length && (!citations || isEmpty(citations)))
    return null;

  return (
    <Layout direction="column" spacing={1}>
      <Text preset="help">
        {intl.formatMessage({
          id: 'SourcesList.sourcesLabel',
          defaultMessage: 'Sources',
          description: 'Label for sources section',
        })}{' '}
      </Text>
      {!!originalSources.length ? (
        <Sources message={message} onSelectSource={onSelectSource} />
      ) : (
        <Citations message={message} onSelectCitation={onSelectCitation} />
      )}
    </Layout>
  );
};
